@if (!tab.showLoader) {
    <div menuSystem [cerrixTab]="tab" class="details">
        <div
            class="screens"
            [attr.name]="'assetmanagement.detail.menuAsset' | transloco"
            menuicon="fas fa-cube"
            menusystemsubmenu
        >
            <div
                [attr.name]="'assetmanagement.detail.menuDetails' | transloco"
                menuItemId="details"
                menuicon="fas fa-info-circle"
                menusystemitem
            >
                <app-cerrix-header
                    [(title)]="model.name"
                    [edit]="true"
                    [titlePlaceholder]="
                        (model.reference === undefined
                            ? 'assetmanagement.detail.newAssetNamePlaceholder'
                            : 'assetmanagement.detail.assetNamePlaceholder'
                        ) | transloco
                    "
                    [breadcrumbs]="breadcrumbs"
                ></app-cerrix-header>
                <div class="body">
                    <div class="input-fields-block">
                        <div class="input-row">
                            <app-asset-owner-selector
                                [users]="users"
                                [ownerId]="model.ownershipInformation?.ownerId"
                                (ownerIdChange)="onOwnerIdChange($event)"
                            ></app-asset-owner-selector>
                            <app-cerrix-datepicker-group
                                format="dd-MM-yyyy"
                                [placeholder]="
                                    'assetmanagement.register.dateInUsePlaceholder' | transloco
                                "
                                [(value)]="model.lifecycle.dateInUse"
                                >{{
                                    "assetmanagement.detail.dateInUseLabel" | transloco
                                }}</app-cerrix-datepicker-group
                            >
                            <app-cerrix-datepicker-group
                                format="dd-MM-yyyy"
                                [placeholder]="
                                    'assetmanagement.register.dateOutOfUsePlaceholder' | transloco
                                "
                                [mustBeAfter]="model.lifecycle.dateInUse"
                                [afterErrorMessage]="
                                    'assetmanagement.edit-lifecycle-information.dateOutOfUseErrorMessage'
                                        | transloco
                                "
                                [(value)]="model.lifecycle.dateOutOfUse"
                                >{{
                                    "assetmanagement.detail.dateOutOfUseLabel" | transloco
                                }}</app-cerrix-datepicker-group
                            >
                        </div>
                        <div class="input-row">
                            <cerrix-textarea-group
                                [data-uiid]="'asset-description'"
                                [name]="'asset-description'"
                                [textareaDialogTitle]="
                                    'assetmanagement.register.descriptionTitle' | transloco
                                "
                                [infoText]="
                                    'assetmanagement.register.descriptionInfoText' | transloco
                                "
                                [rows]="5"
                                placeholder="Enter a description"
                                [value]="model.description"
                                (valueChange)="model.description = $event"
                                >{{
                                    "assetmanagement.register.descriptionTitle" | transloco
                                }}</cerrix-textarea-group
                            >
                        </div>
                        <div class="input-row">
                            <app-cerrix-tree-item-picker-single
                                name="organization-owner"
                                appValidationRequired
                                [items]="organizationOwnerList"
                                [selectedValue]="model.ownershipInformation.owningOrganizationId"
                                [label]="
                                    'assetmanagement.detail.organizationOwnerLabel' | transloco
                                "
                                [placeholder]="
                                    'assetmanagement.edit-ownership-information.organizationPlaceholder'
                                        | transloco
                                "
                                [dialogTitle]="
                                    'assetmanagement.edit-ownership-information.organizationDialogTitle'
                                        | transloco
                                "
                                [infoText]="
                                    'assetmanagement.edit-ownership-information.organizationOwnerInfo'
                                        | transloco
                                "
                                (valueChanged)="
                                    model.ownershipInformation.owningOrganizationId = $event
                                "
                                iconPrefix="third-party"
                                defaultIcon="third-party"
                                >{{
                                    "assetmanagement.detail.organizationOwnerLabel" | transloco
                                }}</app-cerrix-tree-item-picker-single
                            >
                        </div>
                    </div>
                </div>
                <cerrix-page-footer>
                    <div class="asset-management-footer">
                        <div class="left-button-group">
                            <cerrix-button
                                buttonType="secondary"
                                buttonSize="big"
                                secondaryColor="outlined-gray"
                                data-uiid="asset-management-cancel-asset"
                                (click)="cancel()"
                            >
                                {{ "assetmanagement.detail.cancelButton" | transloco }}
                            </cerrix-button>
                            <cerrix-icon-button
                                buttonType="secondary"
                                buttonSize="big"
                                data-uiid="asset-management-save-asset"
                                icon="check"
                                iconPosition="right"
                                [text]="'assetmanagement.detail.registerSaveButton' | transloco"
                                [resultText]="'assetmanagement.detail.savedButton' | transloco"
                                (click)="save()"
                                [disabled]="validationErrors() || !saveButtonEnabled"
                            >
                            </cerrix-icon-button>
                        </div>
                    </div>
                </cerrix-page-footer>
            </div>
        </div>
    </div>
}
